import { useState, useEffect } from 'react';
import Button from '@mui/material/Button'; 
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box'; 
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { DataGrid, GridToolbarContainer, GridToolbarFilterButton } from '@mui/x-data-grid'; 
import { DataGridPro } from '@mui/x-data-grid-pro';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import './emulatorPage.css';
import { format } from 'date-fns';

// import { Link } from "react-router-dom"; 
// const renderDate = (date) => {
//   if (!date) {
//     return '';
//   } 
//   return format(new Date(date), 'dd/MM/yyyy');
// }

// const data_rows = [
//   {
//     group: ['Telegram', 'Chat Group 1'],
//     groupUID: '-12890371920873',
//     lastCollectedDate: new Date(2020, 11, 20),
//     emulator: "hunnycloud1",
//     id: 2,
//   },
//   {
//     group: ['Telegram', 'sgCovid'],
//     groupUID: '-128903719202135',
//     lastCollectedDate: new Date(2020, 11, 20),
//     emulator: "hunnycloud2",    
//     id: 1,
//   },
//   {
//     group: ['WhatsApp', 'Chat Group 2'],
//     groupUID: '128903719202135',
//     lastCollectedDate: new Date(2020, 10, 14),
//     emulator: "hunnycloud3",
//     id: 3,
//   },
//   {
//     group: ['WhatsApp', 'Chat Group 3'],
//     groupUID: '128903719202135',
//     lastCollectedDate: new Date(2017, 10, 29),
//     emulator: "hunnycloud1",
//     id: 4,
//   },
//   {
//     group: ['WeChat', 'Chat Group 1'],
//     groupUID: '128903719202135',
//     lastCollectedDate: new Date(2020, 7, 21),
//     emulator: "hunnycloud2",
//     id: 5,
//   },
//   {
//     group: ['WeChat', 'Chat Group 2'],
//     groupUID: '128903719202135',
//     lastCollectedDate: new Date(2020, 7, 20),
//     emulator: "hunnycloud3",
//     id: 6,
//   },
//   {
//     group: ['WeChat', 'Chat Group 3'],
//     groupUID: '128903719202135',
//     lastCollectedDate: new Date(2019, 6, 28),
//     emulator: "hunnycloud2",
//     id: 7,
//   },
// ];

// const data_columns = [  
//   { 
//     field: 'groupUID', 
//     headerName: 'Group UID', 
//     width: 150, 
//     flex: 1,
//     renderCell: (params) => ( 
//       <Typography>{params.value}</Typography>
//     )
//   },
//   { 
//     field: 'lastCollectedDate',
//     headerName: 'Last Collected Date',
//     type: 'date',
//     width: 150,
//     flex: 1,
//     renderCell: (params) => ( 
//       <Typography>{renderDate(params.value)}</Typography>
//     )    
//   },
//   { 
//     field: 'emulator', 
//     headerName: 'Emulator', 
//     width: 150, 
//     flex: 1,
//     renderCell: (params) => ( 
//       <Typography>{params.value}</Typography>
//     )
//   },
// ];

// const getTreeDataPath = (row) => row.group;

function CustomToolbar() {
  return (
    <GridToolbarContainer> 
      <GridToolbarFilterButton /> 
      <Box sx={{ flexGrow: 1 }} /> 
    </GridToolbarContainer>
  );
}  

function GenerateChips({applications}) {
  return (
    <Box sx={{ display: "flex", flexDisplay: "row", }}>
      {
        applications.map((x) => 
          <Chip 
            size="small"
            sx={{ marginRight: '10px', color: 'white', fontSize: '12px' }}  
            style={{ backgroundColor: (x === "WhatsApp" ? "#1eb79f" : x === "Telegram" ? "#32a7d9" : "#01ce0a") }} 
            label={x} 
          />
        )
      }
    </Box> 
  ) 
}

export default function EmulatorPage(props) {  
  const [copyId, setCopyId] = useState(false);
  const [copyPassword, setCopyPassword] = useState(false);
    
  const copyToClipboard = (value, type) => {
    global.navigator.clipboard.writeText(value);
    if (type === "id") {
      setCopyId(true);
      const timer = setTimeout(() => setCopyId(false), 500);
      return () => clearTimeout(timer);
    } else {
      setCopyPassword(true);
      const timer = setTimeout(() => setCopyPassword(false), 500);
      return () => clearTimeout(timer);
    } 
  }
  
  const rows = [ 
    { 
      id: 1,
      emulator: "hunnycloud1",
      emulator_url: "hunnycloud1.emulator.com",
      login_details: { id: "emulatorid" , password: "emulatorpw"},
      avatar_name: "John Doe",
      applications: ["Telegram", "WhatsApp", "WeChat"] 
    },
    { 
      id: 2,
      emulator: "hunnycloud2",
      emulator_url: "hunnycloud2.emulator.com",
      login_details: { id: "emulatorid" , password: "emulatorpw"},
      avatar_name: "John Doe",
      applications: ["Telegram", "WeChat"] 
    },
    {
      id: 3, 
      emulator: "hunnycloud3",
      emulator_url: "hunnycloud3.emulator.com",
      login_details: { id: "emulatorid" , password: "emulatorpw"},
      avatar_name: "John Doe",
      applications: ["WhatsApp", "WeChat"] 
    }, 
    {
      id: 4, 
      emulator: "hunnycloud4",
      emulator_url: "hunnycloud4.emulator.com",
      login_details: { id: "emulatorid" , password: "emulatorpw"},
      avatar_name: "John Doe",
      applications: ["WhatsApp", "WeChat"] 
    }, 
    {
      id: 5, 
      emulator: "hunnycloud5",
      emulator_url: "hunnycloud5.emulator.com",
      login_details: { id: "emulatorid" , password: "emulatorpw"},
      avatar_name: "John Doe",
      applications: ["WhatsApp", "WeChat"] 
    }     
  ]  
  
  const columns = [
    {
      field: "id"
    },
    {
      field: "emulator",
      headerName: "Emulator",
      minWidth: 150,
      flex: 1,
      sortable: false, 
      renderCell: (params) => ( 
        <Typography>{params.value}</Typography>
      )
    },   
    {
      field: "emulator_url",
      headerName: "Emulator URL",
      minWidth: 150,
      flex: 1,
      sortable: false, 
      renderCell: (params) => ( 
        <Typography>{params.value}</Typography>
      )
    },
    {
      field: "login_details",
      headerName: "Login Details",
      minWidth: 150,
      flex: 1,
      sortable: false, 
      renderCell: (params) => ( 
        <Box sx={{ display: "flex", flexDirection: "column", height: "auto" }}>
          <Tooltip title={copyId ? "Copied!" : ""} leaveDelay={300}>
            <Typography className="copy-id" onClick={() => copyToClipboard(params.value.id, "id")}>{params.value.id}</Typography> 
          </Tooltip>
          <Tooltip title={copyPassword ? "Copied!" : ""} leaveDelay={300}>
            <Typography className="copy-password" onClick={() => copyToClipboard(params.value.password, "pw")}>Copy password</Typography>  
          </Tooltip>
        </Box>
      )
    },    
    {
      field: "avatar_name",
      headerName: "Avatar Name",
      minWidth: 150,
      flex: 1,
      sortable: false, 
      renderCell: (params) => (  
        <Typography>{params.value}</Typography>  
      )
    }, 
    {
      field: "applications",
      headerName: "Applications",
      minWidth: 250,
      flex: 1,
      sortable: false, 
      renderCell: (params) => (<Box sx={{ display: "flex", flexDirection: "row", width: "auto" }}>
        <GenerateChips applications={params.value}/>
      </Box>)     
      // <Chip color="primary" label="test" />
        // <Stack direction="row" spacing={1}> 
        //   {params.value.map((x) => {
        //     <Chip color="primary" label="test" />
        //   })} 
        // </Stack>
    }
  ]
  return (
    <div>
      <h1 className='header'>
          Emulators
      </h1>
      <div style={{ height: '100%', width: "300", paddingBottom: "5rem"}} className='view-tasking-table'>
        <DataGrid    
          initialState={{ 
              pagination: { paginationModel: { pageSize: 10 } },
          }} 
          rows={rows} 
          columns={columns}
          columnVisibilityModel={{ 
            id: false,  
          }}
          pageSizeOptions={[5, 10, 30]}       
          disableSelectionOnClick 
          disableRowSelectionOnClick 
          disableColumnResize 
          disableColumnMenu
          slots={{ toolbar: CustomToolbar }}
          sx={{
              "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                  outline: "none !important", 
              },  
              "&.MuiDataGrid-root .MuiDataGrid-cell": {
                  whiteSpace: "normal !important",
                  wordWrap: "break-word !important", 
                  display: "flex !important",
                  alignItems: "center !important"  
              },
              ".MuiButton-root": {
                  color: "#605958"
              },
              "& .MuiDataGrid-row:hover": {
                  backgroundColor: "rgba(218,218,218,0)", 
              }
          }} 
        />
      </div>      
    </div>
    );
  }      



      // <div style={{ height: '100%', width: "300", paddingBottom: "5rem" }} className='view-tasking-table'>
      //   <DataGridPro
      //     treeData
      //     rows={data_rows}
      //     columns={data_columns}
      //     getTreeDataPath={getTreeDataPath}
      //     disableSelectionOnClick 
      //     disableRowSelectionOnClick 
      //     disableColumnResize 
      //     disableColumnMenu
      //     slots={{ toolbar: CustomToolbar }}
      //     sx={{
      //         "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      //             outline: "none !important", 
      //         },  
      //         "&.MuiDataGrid-root .MuiDataGrid-cell": {
      //             whiteSpace: "normal !important",
      //             wordWrap: "break-word !important", 
      //             display: "flex !important",
      //             alignItems: "center !important"  
      //         },
      //         ".MuiButton-root": {
      //             color: "#605958"
      //         },
      //         "& .MuiDataGrid-row:hover": {
      //             backgroundColor: "rgba(218,218,218,0)", 
      //         }
      //     }} 
      //   />
      // </div>